"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

var _Accordion = _interopRequireDefault(require("../Expander/Accordion"));

var _Expander = _interopRequireDefault(require("../Expander/Expander"));

var _excluded = ["children", "activeIndex", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AccTabs = function AccTabs(_ref) {
  var children = _ref.children,
      activeIndex = _ref.activeIndex,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var accTabsRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState('tabs'),
      displayTabs = _React$useState[0],
      setDisplayTabs = _React$useState[1];

  var _React$useState2 = _react.default.useState(false),
      isReady = _React$useState2[0],
      setIsReady = _React$useState2[1];

  var previousWidthTab = _react.default.useRef(0);

  _react.default.useEffect(function () {
    return resizeTabs();
  }, []);

  _react.default.useLayoutEffect(function () {
    var tabs = accTabsRef.current.querySelectorAll('.uk-tabs__tab span');

    if (Array.from(tabs).length > 0) {
      var widthOfTabs = Array.from(tabs).map(function (child) {
        return child.offsetWidth;
      }).reduce(function (acc, value) {
        return acc + value;
      });
      previousWidthTab.current = widthOfTabs;
    }

    window.addEventListener('resize', resizeTabs);
    return function () {
      return window.removeEventListener('resize', resizeTabs);
    };
  }, []);

  var resizeTabs = function resizeTabs() {
    if (accTabsRef.current.querySelector('.uk-tabs__tab-list')) {
      setIsReady(true);
    }

    if (previousWidthTab.current >= accTabsRef.current.offsetWidth) {
      setDisplayTabs('accordion');
    } else {
      setDisplayTabs('tabs');
    }
  };

  var classes = (0, _clsx.default)('uk-accTabs', !isReady && 'uk-accTabs--rendering', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: accTabsRef,
    className: classes
  }, displayTabs === 'accordion' ? /*#__PURE__*/_react.default.createElement(_Accordion.default, _extends({
    activeIndex: activeIndex
  }, attributes), _react.default.Children.map(children, function (child, i) {
    return child && child.props ? /*#__PURE__*/_react.default.createElement(_Expander.default, _extends({
      key: i
    }, child.props)) : null;
  })) : /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    activeIndex: activeIndex
  }, children));
};

AccTabs.propTypes = {
  /**
   * Set to open by default an Expander/Tab (0-based index)
   */
  activeIndex: _propTypes.default.number
};
AccTabs.defaultProps = {};
var _default = AccTabs;
exports.default = _default;